export const actionTypes = {
	SET_TREND_COMMENTS_DRAWER_VISIBLE: 'operationalParameters_v2/SET_TREND_COMMENTS_DRAWER_VISIBLE',
	SET_TREND_COMMENTS_MODAL_VISIBLE: 'operationalParameters_v2/SET_TREND_COMMENTS_MODAL_VISIBLE',
	GET_TREND_COMMENTS_LIST_SETTINGS: 'operationalParameters_v2/GET_TREND_COMMENTS_LIST_SETTINGS',
	CREATE_AND_EDIT_TREND_COMMENT_SETTINGS: 'operationalParameters_v2/CREATE_AND_EDIT_TREND_COMMENT_SETTINGS',
	CLEAR_CREATE_EDIT_TREND_COMMENT_ERROR: 'operationalParameters_v2/CLEAR_CREATE_EDIT_TREND_COMMENT_ERROR',
	DELETE_TREND_COMMENT_SETTINGS: 'operationalParameters_v2/DELETE_TREND_COMMENT_SETTINGS',
	CLEAR_DELETE_TREND_COMMENT_ERROR: 'operationalParameters_v2/CLEAR_DELETE_TREND_COMMENT_ERROR',
	RESET_TREND_COMMENT_SELECTION: 'operationalParameters_v2/RESET_TREND_COMMENT_SELECTION',

	//Saga API
	GET_TREND_COMMENTS_LIST_REQUEST: 'operationalParameters_v2/GET_TREND_COMMENTS_LIST_REQUEST',
	CREATE_AND_EDIT_TREND_COMMENT_REQUEST: 'operationalParameters_v2/CREATE_AND_EDIT_TREND_COMMENT_REQUEST',
	DELETE_TREND_COMMENT_REQUEST: 'operationalParameters_v2/DELETE_TREND_COMMENT_REQUEST',
};

export const maxSubjectCount = 100;

export const commentTextMaxLength = 500;
